import { render, staticRenderFns } from "./productSliderItem.vue?vue&type=template&id=1356d657"
import script from "./productSliderItem.vue?vue&type=script&lang=js"
export * from "./productSliderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports